import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-analytics-time-selector',
    templateUrl: './analytics-time-selector.component.html',
    standalone: false
})
export class AnalyticsTimeSelectorComponent implements OnInit {
  @Input() label: string = 'Time';

  @Input() disabled: boolean = false;

  @Output() selectedOptionChange = new EventEmitter<string>();

  public selectedOption = '1d'; // Default is "24 hours"

  public optionList = [
    { value: '1d', viewValue: 'Last 24 hours' },
    { value: '1w', viewValue: 'Last 7 days' },
    { value: '2w', viewValue: 'Last 14 days' },
    { value: '1m', viewValue: 'Last month' },
  ];

  ngOnInit(): void {
    this.emitSelectedOption();
  }

  emitSelectedOption(): void {
    this.selectedOptionChange.emit(this.selectedOption);
  }

  onSelectionChange(value: string): void {
    this.selectedOption = value;
    this.emitSelectedOption();
  }
}
